module.exports = __webpack_public_path__ + "img/performance-tiao-icon2.06960937.png";